import React, { useEffect } from "react";
import MainLayout from "../../layout/MainLayout";
import CustomerDetailWeb from "../../assets/svg/web-cus-detail.svg";
import DetailForm from "./detailForm";
import BackArrow from "../../assets/svg/back-arrow.svg";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ROUTE_PATH from "../../constant/route";

function CustomerDetails() {
  const navigate = useNavigate()
  const userData = useSelector((state: any) => state);
  const {
    home: { totalPrice },
  } = userData;

  useEffect(()=>{
    if(Number(totalPrice) === 0){
      navigate(ROUTE_PATH.HOME)
    }
  },[])
  return (
    <MainLayout>
      <div className="lg:pl-[60px] lg:pr-[60px] lg:pb-[80px] lg:pt-[100px] pt-[13px] px-[16px] pb-[50px] bg-bg-color-3 lg:bg-bg-color-5">
        <div className="block lg:flex items-center w-[100%] lg:w-[80%] m-auto">
          <div className="lg:w-1/2">
            <div className="block lg:hidden relative flex">
              <img
                src={BackArrow}
                alt="BackArrow"
                className="relative left-[-3%]"
                onClick={()=>navigate(-1)}
              />
              <div className="text-[16px] sm:text-[20px] sm:leading-[20px] font-bold leading-[20px] text-text-color-6 mt-[3%] sm:mt-[1.5%] relative left-[-3%]">
                Customer details
              </div>
            </div>
            <div className="lg:text-[46px] font-bold lg:leading-[60px] text-text-color-6 hidden lg:block">
              Customer
              <br />
              details
            </div>
          </div>
          <div className="lg:w-1/2">
            <img
              src={CustomerDetailWeb}
              alt="CustomerDetailWeb"
              className="w-[100%] relative mb-[-6%] lg:mb-[0]"
            />
          </div>
        </div>
        <div className="bg-bg-color-6 lg:p-[70px] p-[14px] pb-[30px] lg:rounded-[30px] rounded-[16px] lg:mt-[60px] w-[100%] lg:w-[80%] m-auto shadow-md relative z-10">
          <DetailForm />
        </div>
      </div>
    </MainLayout>
  );
}

export default CustomerDetails;
